import {usePublic} from "@shared/hooks/usePublic.ts";
import {useUsuario} from "@components/usuario/hooks/useUsuario.ts";
import {IUsuario} from "@models/conta/IUsuario.ts";
import {ImportDataComponent, ImportDataComponentProps} from "@components/shared/ImportDataComponent.tsx";
import {ICreateUsuarioDto} from "@components/usuario/dto/input/ICreateUsuarioDto.ts";

interface ImportUsuarioProps {
    onCreate: () => void
}

export function ImportUsuariosComponent(props: ImportUsuarioProps) {
    const {onCreate} = props;
    const {importUsuarios} = useUsuario()
    const {getTemplate} = usePublic()

    const importProps: ImportDataComponentProps<ICreateUsuarioDto, IUsuario> = {
        onCreate: onCreate,
        filename: "usuarios.csv",
        importMethod: importUsuarios,
        permissao: ["CriarProduto"],
        previewGrid: [{field: 'nome', headerName: 'Nome', width: 100},
            {field: 'email', headerName: 'Código Reduzido', width: 150},
        ],
        templateUrl: getTemplate('usuario', 'import-example')
    }

    return (
        <ImportDataComponent {...importProps}/>
    )
}